import React from 'react';

const PhoneIcon = () => (
    <svg
        width="10"
        height="10"
        viewBox="0 0 10 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M9.71482 7.06635L7.52728 6.12884C7.43383 6.08901 7.32997 6.08062 7.23134 6.10493C7.13271 6.12923 7.04464 6.18492 6.98039 6.26361L6.01163 7.44722C4.49124 6.73037 3.26767 5.50681 2.55083 3.98642L3.73444 3.01765C3.81328 2.95352 3.86909 2.86545 3.89341 2.76678C3.91772 2.6681 3.90923 2.56418 3.86921 2.47077L2.93169 0.283226C2.88777 0.182523 2.81008 0.100302 2.71203 0.0507415C2.61398 0.00118072 2.50171 -0.0126136 2.39457 0.0117372L0.363288 0.480495C0.259999 0.504347 0.167844 0.562505 0.101864 0.645476C0.0358845 0.728447 -2.37936e-05 0.831332 1.18287e-08 0.93734C1.18287e-08 5.94719 4.06062 10 9.06266 10C9.1687 10.0001 9.27163 9.96418 9.35464 9.8982C9.43765 9.83221 9.49584 9.74003 9.5197 9.63671L9.98845 7.60543C10.0126 7.49777 9.99856 7.38505 9.94862 7.28666C9.89867 7.18827 9.816 7.11037 9.71482 7.06635Z"
            fill="#9CA8BB"
        />
    </svg>
);

export default PhoneIcon; 